/**
 * Created by ivan on 11.04.18.
 */

const ClansToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.CLANS);

    this.enable();
};

ClansToolbarItem.prototype = Object.create(ToolbarItem.prototype);
ClansToolbarItem.prototype.constructor = ClansToolbarItem;

ClansToolbarItem.prototype.resetState = function () {
    this.hasReq = cleverapps.clanMessages.needsAttention();
    if (this.hasReq) {
        this.mark();
    } else {
        this.unmark();
    }
};

ClansToolbarItem.prototype.isVisible = function () {
    return Clans.IsAvailable() && cleverapps.environment.isMainScene() && cleverapps.meta.getSelectedLocation().locationConfig.isMain;
};

ClansToolbarItem.prototype.onClick = function () {
    let noConnection = false;

    cleverapps.focusManager.display({
        focus: "ClansIconClicked",
        control: ["MenuBarLivesItem", "MenuBarGoldItem", "MenuBarCoinsItem"],
        actions: [
            function (f) {
                f = cleverapps.wait(2, f);

                cleverapps.userClan.load(f, () => {
                    noConnection = true;
                    f();
                });

                if (cleverapps.userClan.id !== undefined) {
                    f();
                } else {
                    cleverapps.clans.search(undefined, f);
                }
            },

            function (f) {
                if (noConnection) {
                    new NoConnectionWindow();
                } else if (cleverapps.userClan.id !== undefined) {
                    new MyClanWindow({ hasReq: this.hasReq });
                } else {
                    new ClansWindow();
                }

                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        ]
    });
};